import ComingSoon from "../../../components/ui/ComingSoon/ComingSoon";
import PageHeader from "../../pageheader/components/PageHeader"

const UserProfilePage: React.FC = () => {
    return (
        <>
            <PageHeader name="User Profile"></PageHeader>
            <ComingSoon />
        </>
    )
}

export default UserProfilePage;